module.exports = __webpack_public_path__ + "img/invalid.b8bd137c.png";